// A media-library image as stored on a product (the imageWidget value):
//   { url: '.../library/<file>', sizes: [60, 150, ...], ... }
// Each size n is generated next to the original as '<n>_<file>'.

// URL of the smallest generated version, or the original when no sizes were generated.
export const imageThumbnailUrl = (image) => {
  if (!image || typeof image.url !== 'string' || !image.url) return null
  const sizes = Array.isArray(image.sizes) ? image.sizes.filter((s) => Number(s) > 0) : []
  if (sizes.length === 0) return image.url
  const smallest = Math.min(...sizes.map(Number))
  const parts = image.url.split('/')
  const file = parts.pop()
  return [...parts, smallest + '_' + file].join('/')
}
